import { managerAxios } from "../axiosInstance";
import { notify } from "../components/toastify";
import { Navigate } from "react-router";

// let hasNotified = false;
export const fetchData = async (
  endpoint,
  page = 1,
  search = "",
  formData = {}
) => {
  try {
    let url = `${endpoint}?page=${page}`;
    if (search) {
      url += `&searchParam=${search}`; // Correctly append search parameter
    }

    const response = await managerAxios.post(url, formData);

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      return <Navigate to="/login" />; // Redirect to login
    }
    notify(error?.message);
  }
};

export const fetchOnlyData = async (endpoint) => {
  try {
    let url = `${endpoint}`;

    const response = await managerAxios.get(url, {});
    return response?.data?.data;
  } catch (error) {
    // if (!hasNotified) {
    if (error.response?.status === 401) {
      return <Navigate to="/login" />; // Redirect to login
    }
    notify(error.response.data.message || error.message);

    throw new Error(error.response?.data?.message || error.message);
    // throw new Error("Error fetching data" + error.message);
  }
};

export const createData = async (endpoint, data, showNotification) => {
  try {
    const response = await managerAxios.post(`${endpoint}`, data);
    if (showNotification) {
    } else {
      notify(response.data.message, "success");
    }
    return response.data; // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);
    return error;
  }
};

export const updateData = async (endpoint, id, data) => {
  try {
    const response = await managerAxios.put(`${endpoint}${id}`, data);
    notify(response?.data?.message, "success");

    return response?.data;
    // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);
    return error;
  }
};

export const deleteData = async (endpoint, id) => {
  try {
    const response = await managerAxios.delete(`${endpoint}${id}`);
    notify(response?.data?.message, "success");
    return response?.data; // Adjust based on the structure of your response
  } catch (error) {
    notify(error?.response?.data?.message || error.message);
  }
};

export const getDataById = async (endpoint, id) => {
  try {
    const response = await managerAxios.get(`${endpoint}${id}`);
    // notify(response.data.message);
    return response; // Adjust based on the structure of your response
  } catch (error) {
    notify(error.response.data.message || error.message);
  }
};
